export const MENEMOSINE_ENTITY_TYPES = [
  { value: 'Deadline', name: 'Prazo' },
  { value: 'PendingContract', name: 'Contrato pendente' },
  { value: 'Contact', name: 'Contato' },
]
